import { store } from '../../store'
import { http, httpgst } from '../../main'

const state = {}

const getters = {}

const actions = {
  get ({ commit, dispatch }, payload) {
    let url = `api/reports/by-annual-expenses/${payload.event.item.url}`
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGet', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  getLogged ({ commit, dispatch }, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetLogged', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  downloadReport ({ commit, dispatch }, payload) {
    let url = `api/reports/by-annual-expenses/${payload.event.item.url}`
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      responseType: 'blob'
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, params, options)
      .then(
        response => {
          commit('onDownloadReport', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  }
}

const mutations = {
  onGetLogged (state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
    payload.event.context.companyId = userLogged.company[0].id
    payload.event.context.getBranches()
    payload.event.context.search()
  },
  onGet (state, payload) {
    let report = payload.response.data.data
    payload.event.context.expenseItems = report
    let expensesItems = payload.response.data.data.expensesItemsByMonth
    if (expensesItems !== null) {
      let months = Object.getOwnPropertyNames(expensesItems)
      months.pop()
      let newItems = []
      for (let i = 0; i < months.length; i++) {
        const item = months[i]
        if (item !== '0') {
          let temp = {
            month: parseInt(item),
            items: expensesItems[item]
          }
          newItems.push(temp)
        }
      }
      expensesItems = newItems
    }
    payload.event.context.expensesItems = expensesItems
    payload.event.context.createItems()
    payload.event.context.loadingItems = false
  },
  onDownloadReport (state, payload) {
    let date = payload.event.context.getReportDate()
    payload.event.context.forceFileDownload(payload.response.data, `AnnualExpensesType ${payload.event.context.year} ${date}.xlsx`)
    payload.event.context.loadingDownload = false
  },
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loadingItems = false
    payload.event.context.loadingDownload = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/annualExpensesReport.js